import { MAX_PER_PAGE } from '../constants/Pagination';

export const PaginationHelper = () => {
  const getOffsetFromPage = (page: number) => {
    return (page - 1) * MAX_PER_PAGE;
  };

  return {
    getOffsetFromPage,
  };
};
